import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { WhoIHelp } from "@/components/WhoIHelp";
import { Services } from "@/components/Services";
import { Story } from "@/components/Story";
import { WhyMe } from "@/components/WhyMe";
import { Philosophy } from "@/components/Philosophy";
import { Faith } from "@/components/Faith";
import { Sponsor } from "@/components/Sponsor";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-cream text-ink font-body antialiased overflow-x-clip">
      <Nav />
      <main>
        <Hero />
        <Marquee
          items={["STRENGTH", "CONFIDENCE", "FAITH", "DISCIPLINE", "GROWTH", "COMMUNITY", "COMEBACKS", "PURPOSE"]}
          variant="ink"
          rotate="-rotate-1"
        />
        <About />
        <WhoIHelp />
        <Services />
        <Story />
        <WhyMe />
        <Philosophy />
        <Faith />
        <Sponsor />
        <Marquee
          items={["START WHERE YOU ARE", "EVOLVE INTO WHO YOU'RE MEANT TO BE", "NO GATEKEEPING", "FAITH • GRIT • GROWTH"]}
          variant="lime"
          rotate="rotate-1"
        />
        <Contact />
      </main>
      <Footer />
      <div className="grain" aria-hidden="true" />
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
